import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// 선생님의 고유 설정값 적용 완료
const firebaseConfig = {
  apiKey: "AIzaSyB3teO6Gh10-IEuze20eSmdr4Th-pbWu9s",
  authDomain: "junket-system.firebaseapp.com",
  projectId: "junket-system",
  storageBucket: "junket-system.firebasestorage.app",
  messagingSenderId: "515288287512",
  appId: "1:515288287512:web:ad1a4646068d03d3fab66d"
};

// 파이어베이스 초기화 및 DB 내보내기
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);